import * as React from 'react';
import {view, createViewConfig} from '@sail/engine';
import {useCollectionState} from '@sail/react-aria';

export type ListBoxClearItemProps = {
  children: React.ReactNode;
};

export const ListBoxClearItemConfig = createViewConfig({
  name: 'ListBoxClearItem',
  props: {} as ListBoxClearItemProps,
});

export const ListBoxClearItem = ListBoxClearItemConfig.createView(
  (allProps) => {
    const {children, ...props} = allProps;

    const state = useCollectionState();

    return (
      <view.div
        role="option"
        aria-selected="false"
        data-testid="clear-selection"
        onClick={() => {
          state.selectionManager.setSelectedKeys(new Set([]));
        }}
        {...props}
      >
        {children}
      </view.div>
    );
  },
  {
    css: {
      stack: 'x',
      font: 'label.medium',
      color: 'form.placeholder',
      gap: 'space.75',
      borderRadius: 'xsmall',
      paddingY: 'space.75',
      paddingX: 'space.125',
      alignY: 'baseline',
      alignX: 'start',
      cursor: 'pointer',

      ':hover': {
        backgroundColor: 'offset',
      },
    },
  },
);
